<template>
  <div class="container">
    <register-head
      :changeStep="changeStep"
      :stepForm="stepForm"
      :steps="steps"
      :page="`company`"
    ></register-head>

    <fade-transition :duration="200" origin="center top" mode="out-in">
      <!-- Step 1 -->
      <div :class="stepForm === 3 || stepForm === 0 ? `` : `d-none`">
        <register-form
          :formStepId="0"
          :stepForm="stepForm"
          :step="steps[0]"
          :realStep="0"
        >
          <div class="form-group">
            <label style="color: #A72C32;" class="font-weight-bold"
            >* จำเป็นต้องกรอกข้อมูล</label
            >
          </div>
          <div class="form-group">
            <label for="inputEmail" class="font-weight-bold required"
            >E-mail (ใช้สำหรับการ Login เข้าสู่ระบบ)</label
            >
            <input
              :disabled="stepForm === 3"
              type="email"
              class="form-control form-control-user"
              id="inputEmail"
              v-model="form.contact_person.email"
              @keyup="checkEmail(form.contact_person.email)"
              placeholder="Email Address"
              style="padding: 1.2rem 1rem;"
              :style="isEmailFormat ? `` : `border-color: #A72C32`"
            />
          </div>
          <div class="form-group row">
            <div class="col-sm-6 mb-3 mb-sm-0 ">
              <label for="inputPassword" class="font-weight-normal required"
              >รหัสผ่าน</label
              >
              <input
                :disabled="stepForm === 3"
                type="password"
                class="form-control form-control-user "
                id="inputPassword"
                v-model="form.password"
                @change="checkPassword(form.password, form.repeat_password)"
                placeholder="Password "
                style="padding: 1.2rem 1rem;"
                :style="isPasswordFormat ? `` : `border-color: #A72C32`"
              />
            </div>
            <div class="col-sm-6 ">
              <label for="repeatPassword" class="font-weight-normal required"
              >ยืนยันรหัสผ่าน</label
              >
              <input
                :disabled="stepForm === 3"
                type="password"
                class="form-control form-control-user "
                id="repeatPassword"
                v-model="form.repeat_password"
                @change="checkPassword(form.password, form.repeat_password)"
                placeholder="Repeat Password "
                style="padding: 1.2rem 1rem;"
                :style="isPasswordFormat ? `` : `border-color: #A72C32`"
              />
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12 ">
              <h5 class="required">ผู้ประสานงาน</h5>
            </div>
          </div>
          <div class="form-group row ">
            <div class="col-sm-6 mb-3 mb-sm-0 ">
              <label for="firstName">ชื่อ</label>
              <input
                :disabled="stepForm === 3"
                type="text"
                class="form-control form-control-user"
                id="firstName"
                v-model="form.contact_person.firstName"
                placeholder="First Name"
                style="padding: 1.2rem 1rem;"
              />
            </div>
            <div class="col-sm-6 ">
              <label for="lastName">นามสกุล</label>
              <input
                :disabled="stepForm === 3"
                type="text"
                class="form-control form-control-user"
                id="lastName"
                v-model="form.contact_person.lastName"
                placeholder="Last Name"
                style="padding: 1.2rem 1rem;"
              />
            </div>
          </div>
          <div class="form-group row ">
            <div class="col-sm-6 mb-3 mb-sm-0 ">
              <label for="position">ตำแหน่ง</label>
              <input
                :disabled="stepForm === 3"
                type="text"
                class="form-control form-control-user"
                id="position"
                v-model="form.contact_person.position"
                placeholder="Position"
                style="padding: 1.2rem 1rem;"
              />
            </div>
            <div class="col-sm-6 ">
              <label for="phoneNumber">โทรศัพท์</label>
              <input
                :disabled="stepForm === 3"
                type="text"
                class="form-control form-control-user"
                id="phoneNumber"
                v-model="form.contact_person.phone"
                placeholder="08x-xxx-xxxx"
                style="padding: 1.2rem 1rem;"
              />
            </div>
          </div>

          <div class="form-group row mt-5">
            <div class="col-sm-12 mb-3 mb-sm-0 ">
              <label for="corporate_name_th" class="required"
              >ชื่อสถานประกอบการ (ภาษาไทย)
              </label>
              <input
                :disabled="stepForm === 3"
                type="text"
                class="form-control form-control-user"
                id="corporate_name_th"
                v-model="form.name.th"
                placeholder=""
                style="padding: 1.2rem 1rem;"
              />
            </div>
          </div>
          <div class="form-group row mb-3">
            <div class="col-sm-12 mb-3 mb-sm-0 ">
              <label for="corporate_name_en" class="required"
              >ชื่อสถานประกอบการ (ภาษาอังกฤษ)
              </label>
              <input
                :disabled="stepForm === 3"
                type="text"
                class="form-control form-control-user"
                id="corporate_name_en"
                v-model="form.name.en"
                placeholder=""
                style="padding: 1.2rem 1rem;"
              />
            </div>
          </div>

          <div class="row mt-5 mb-2">
            <div class="col-12">
              <h5 class="required">กลุ่มอุตสาหกรรม</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12 font-weight-normal">
              <div
                class="form-group row custom-control custom-radio ml-2"
                v-for="(industry, industryId) in industryGroup"
                :key="`industryId${industryId}`"
              >
                <div
                  :class="
                    industryId !== industryGroup.length - 1 ? `col-12` : `col-3`
                  "
                >
                  <input
                    :disabled="stepForm === 3"
                    class="custom-control-input"
                    :id="`industryRadio${industryId}`"
                    type="radio"
                    :value="industry"
                    v-model="form.industry_group.industry"
                  />
                  <label
                    class="custom-control-label"
                    :for="`industryRadio${industryId}`"
                  >{{ industry }}</label
                  >
                </div>
                <div
                  v-if="
                    industryId === industryGroup.length - 1 &&
                      form.industry_group.industry ===
                        industryGroup[industryGroup.length - 1]
                  "
                  class="col-4"
                >
                  <input
                    :disabled="stepForm === 3"
                    type="text"
                    class="form-control form-control-user"
                    v-model="form.industry_group.otherIndustry"
                    placeholder=""
                    style="padding: 1.2rem 1rem;"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12 ">
              <h5 class="required">สถานที่ตั้ง</h5>
            </div>
          </div>
          <div class="form-group">
            <label for="inputStreet" class="font-weight-normal"
            >อาคาร/ถนน</label
            >
            <input
              :disabled="stepForm === 3"
              type="text"
              class="form-control form-control-user "
              id="inputStreet"
              v-model="form.address.building_road"
              placeholder="เลขที่, ชั้น, อาคาร, ถนน, อื่นๆ"
              style="padding: 1.2rem 1rem;"
            />
          </div>
          <div class="form-group row">
            <div class="col-sm-6 mb-3 mb-sm-0 ">
              <label for="inputProvince" class="font-weight-normal"
              >จังหวัด</label
              >
              <select
                :disabled="stepForm === 3"
                class="form-control round"
                id="inputProvince"
                v-model="form.address.province"
                style="border-radius: 10rem;"
              >
                <option disabled value="">เลือกจังหวัด</option>
                <template v-for="(province, pid) in allProvince">
                  <option
                    :value="[province.id, province.name.th]"
                    :key="`${pid} ${province.id}`"
                  >{{ province.name.th }}
                  </option>
                </template>
              </select>
            </div>
            <div class="col-sm-6 ">
              <label for="inputCity" class="font-weight-normal"
              >เขต/อำเภอ</label
              >
              <select
                :disabled="stepForm === 3"
                class="form-control round"
                id="inputCity"
                v-model="form.address.city"
                style="border-radius: 10rem;"
              >
                <option disabled value="">เลือกอำเภอ</option>
                <template v-for="(city, cid) in allCity">
                  <option
                    v-if="city.province_id === form.address.province[0]"
                    :value="[city.id, city.name.th]"
                    :key="`${cid} ${city.id}`"
                  >{{ city.name.th }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-6 mb-3 mb-sm-0 ">
              <label for="inputPost" class="font-weight-normal"
              >รหัสไปรษณีย์</label
              >
              <input
                :disabled="stepForm === 3"
                type="text"
                class="form-control form-control-user "
                id="inputPost"
                v-model="form.address.zip_code"
                placeholder=""
                style="padding: 1.2rem 1rem;"
              />
            </div>
          </div>
        </register-form>
      </div>
    </fade-transition>

    <fade-transition :duration="200" origin="center top" mode="out-in">
      <!-- Step 2 -->
      <div :class="stepForm === 3 || stepForm === 1 ? `` : `d-none`">
        <register-form
          :formStepId="1"
          :stepForm="stepForm"
          :step="steps[1]"
          :stepBefore="steps[0]"
          :realStep="1"
        >
          <div class="row mt-2">
            <div class="col-3">
              <file-pond
                :disabled="stepForm === 3"
                name="formDisplay"
                ref="formDisplay"
                class-name="my-pond"
                label-idle="Click or Drop files here..."
                maxFileSize="5MB"
                :allow-multiple="false"
                accepted-file-types="image/jpeg, image/png"
                v-model="form.display"
              />
            </div>
            <div class="col-8">
              <h5 class="required">Display</h5>
              <p class="mb-2">.JPEG, .PNG ขนาดไฟล์ไม่เกิน 5MB</p>
            </div>
          </div>

          <div class="row mt-5 mb-2">
            <div class="col-12">
              <label class="h5 required" for="textarea1"
              >ข้อมูลเกี่ยวกับบริษัท</label
              >
            </div>
          </div>
          <div class="form-group row mx-2">
            <textarea
              :disabled="stepForm === 3"
              v-model="form.description"
              class="form-control"
              id="textarea1"
              rows="10"
              placeholder="ระบุข้อมูลเกี่ยวกับบริษัท"
            ></textarea>
          </div>

          <div class="row mt-5 mb-2">
            <div class="col-12">
              <label class="h5 required" for="textarea2">ตำแหน่งที่รับ</label>
            </div>
          </div>
          <div class="form-group row mx-2 mb-3">
            <textarea
              :disabled="stepForm === 3"
              v-model="form.available_job"
              class="form-control"
              id="textarea2"
              rows="10"
              placeholder="ระบุตำแหน่งที่รับ"
            ></textarea>
          </div>

          <div class="row mt-5 mb-2">
            <div class="col-12">
              <label class="h5 required" for="textarea2">สาขาที่รับ</label>
            </div>
          </div>
          <div class="row">
            <div class="col-12 font-weight-normal row">
              <div
                class="form-group row custom-control custom-checkbox custom-control-solid ml-2 ml-sm-4 mb-2 d-flex justify-content-start"
              >
                <div
                  class="col-6 col-sm-5"
                  v-for="(faculty, facultyId) in faculties"
                  :key="`facultyId${facultyId}`"
                >
                  <input
                    :disabled="stepForm === 3"
                    class="custom-control-input"
                    :id="`facultyCheckedbox${facultyId}`"
                    type="checkbox"
                    :value="faculty"
                    v-model="form.interest_faculties"
                  />
                  <label
                    class="custom-control-label"
                    :for="`facultyCheckedbox${facultyId}`"
                  >{{ faculty }}</label
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12 ">
              <h5 class="required">โปสเตอร์/โบรชัวร์</h5>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-3">
              <file-pond
                :disabled="stepForm === 3"
                name="formBrochure"
                ref="formBrochure"
                class-name="my-pond"
                label-idle="Click or Drop files here..."
                maxFileSize="5MB"
                :allow-multiple="false"
                accepted-file-types="image/jpeg, image/png, application/pdf, application/x-pdf, application/x-bzpdf, application/x-gzpdf"
                v-model="form.brochure"
              />
            </div>
            <div class="col-8">
              <label class="font-weight-normal"
              >สามารถแนบโปสเตอร์หรือโบรชัวร์ เพื่อแสดงผลใต้ข้อมูล <br> หากมีมากกว่า 1 ภาพ/ไฟล์ กรุณารวมเป็น PDF 1
                ไฟล์</label
              >
              <p class="mb-2">.JPEG, .PNG, .PDF ขนาดไฟล์ไม่เกิน 5MB</p>
            </div>
          </div>

          <div class="row mt-5 mb-2">
            <div class="col-12">
              <label class="h5 required" for="emailForContactBack"
              >E-mail สำหรับนักศึกษาติดต่อกลับ</label
              >
            </div>
          </div>
          <div class="form-group row mx-2">
            <input
              :disabled="stepForm === 3"
              type="text"
              class="form-control form-control-user"
              id="emailForContactBack"
              v-model="form.email"
              placeholder="E-mail สำหรับนักศึกษาติดต่อกลับ"
              style="padding: 1.2rem 1rem;"
            />
          </div>

          <div class="row mt-5 mb-2">
            <div class="col-12">
              <label class="h5 required" for="WebsiteForContact"
              >เว็บไซต์/เพจ ข้อมูลเพิ่มเติม</label
              >
            </div>
          </div>
          <div class="form-group row mx-2">
            <input
              :disabled="stepForm === 3"
              type="text"
              class="form-control form-control-user"
              id="WebsiteForContact"
              v-model="form.website"
              placeholder="เว็บไซต์/เพจ ข้อมูลเพิ่มเติม (link)"
              style="padding: 1.2rem 1rem;"
            />
          </div>
        </register-form>
      </div>
    </fade-transition>

    <fade-transition :duration="200" origin="center top" mode="out-in">
      <!-- Step 3 -->
      <div :class="stepForm === 3 || stepForm === 2 ? `` : `d-none`">
        <register-form
          :formStepId="2"
          :stepForm="stepForm"
          :step="steps[2]"
          :stepBefore="steps[1]"
          :realStep="2"
        >
          <div class="form-group row custom-control custom-radio ml-2">
            <div class="col-12">
              <input
                :disabled="stepForm === 3"
                class="custom-control-input"
                id="meetingRadio1"
                type="radio"
                :value="true"
                v-model="form.online_meeting"
              />
              <label
                class="h5 custom-control-label text-engineer"
                for="meetingRadio1"
              >มีช่องทางสำหรับ Video Call/Online Meeting ในช่วง Job Fair</label
              >
            </div>
          </div>
          <template v-if="form.online_meeting">
            <template v-for="(range, rangeId) in onlineMeetingRanges">
              <div
                :key="`onlineMeetingRanges ${rangeId}`"
                class="form-group custom-control custom-checkbox custom-control-solid ml-3 ml-sm-5 mb-4"
              >
                <div class="row">
                  <div class="col-12">
                    <input
                      :disabled="stepForm === 3"
                      class="custom-control-input"
                      :id="`date${rangeId}`"
                      :value="range"
                      type="checkbox"
                      v-model="form.meeting_times"
                      @change="selectedDate(range)"
                    />
                    <label
                      class="custom-control-label"
                      :for="`date${rangeId}`"
                    >{{ getDateth(range.date) }}</label
                    >
                    <template v-if="range.checked">
                      <!-- Morning Section -->
                      <div class="row my-2">
                        <div
                          class="offset-1 col-10 d-flex align-items-center justify-content-start"
                        >
                          <div class="col-2">
                            <input
                              :disabled="stepForm === 3"
                              class="custom-control-input"
                              :id="`${range.date}_morning`"
                              type="checkbox"
                              @change="selectedRange(range, `morning`)"
                            />
                            <label
                              class="custom-control-label"
                              :for="`${range.date}_morning`"
                            ><i class="far fa-clock"></i> ช่วงเช้า</label
                            >
                          </div>
                          <div class="col-5 col-sm-4 mb-3 mb-sm-0 ">
                            <select
                              v-model="range.ranges.morning.start_time"
                              class="form-control round"
                              :id="`${range.date}_morning_start`"
                              style="border-radius: 10rem;"
                            >
                              <option disabled value="">เลือกเวลา</option>
                              <option value="09.00">09.00</option>
                              <option value="09.30">09.30</option>
                              <option value="10.00">10.00</option>
                              <option value="10.30">10.30</option>
                              <option value="11.00">11.00</option>
                              <option value="11.30">11.30</option>
                              <option value="12.00">12.00</option>
                            </select>
                          </div>
                          <div class="">ถึง</div>
                          <div class="col-5 col-sm-4 ">
                            <select
                              v-model="range.ranges.morning.end_time"
                              class="form-control round"
                              :id="`${range.date}_morning_end`"
                              style="border-radius: 10rem;"
                            >
                              <option disabled value="">เลือกเวลา</option>
                              <option value="09.30">09.30</option>
                              <option value="10.00">10.00</option>
                              <option value="10.30">10.30</option>
                              <option value="11.00">11.00</option>
                              <option value="11.30">11.30</option>
                              <option value="12.00">12.00</option>
                              <option value="12.30">12.30</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <!-- Morning Meeting Link -->
                      <div class="form-group row">
                        <div class="offset-1 col-10">
                          <label
                            :for="`${range.date}_morning_inputLink`"
                            class="font-weight-normal required"
                          >Link</label
                          >
                          <input
                            v-model="range.ranges.morning.meeting_link"
                            :disabled="stepForm === 3"
                            type="text"
                            class="form-control col-10 form-control-user "
                            :id="`${range.date}_morning_inputLink`"
                            placeholder="Link Meeting Room "
                            style="padding: 1.2rem 1rem;"
                          />
                          <small class="input-hint"><small class="red-color">*</small>เฉพาะ Zoom meeting และ Microsoft Team meeting เท่านั้น</small>
                        </div>
                      </div>

                      <!-- Afternoon Section -->
                      <div class="row my-2">
                        <div
                          class="offset-1 col-10 d-flex align-items-center justify-content-start"
                        >
                          <div class="col-2">
                            <input
                              :disabled="stepForm === 3"
                              class="custom-control-input"
                              :id="`${range.date}_afternoon`"
                              type="checkbox"
                              @change="selectedRange(range, `afternoon`)"
                            />
                            <label
                              class="custom-control-label"
                              :for="`${range.date}_afternoon`"
                            ><i class="far fa-clock"></i> ช่วงบ่าย</label
                            >
                          </div>
                          <div class="col-5 col-sm-4 mb-3 mb-sm-0 ">
                            <select
                              v-model="range.ranges.afternoon.start_time"
                              class="form-control round"
                              :id="`${range.date}_afternoon_start`"
                              style="border-radius: 10rem;"
                            >
                              <option disabled value="">เลือกเวลา</option>
                              <option value="12.00">12.00</option>
                              <option value="12.30">12.30</option>
                              <option value="13.00">13.00</option>
                              <option value="13.30">13.30</option>
                              <option value="14.00">14.00</option>
                              <option value="14.30">14.30</option>
                              <option value="15.00">15.00</option>
                              <option value="15.30">15.30</option>
                            </select>
                          </div>
                          <div class="">ถึง</div>
                          <div class="col-5 col-sm-4 ">
                            <select
                              v-model="range.ranges.afternoon.end_time"
                              class="form-control round"
                              :id="`${range.date}_afternoon_end`"
                              style="border-radius: 10rem;"
                            >
                              <option disabled value="">เลือกเวลา</option>
                              <option value="12.30">12.30</option>
                              <option value="13.00">13.00</option>
                              <option value="13.30">13.30</option>
                              <option value="14.00">14.00</option>
                              <option value="14.30">14.30</option>
                              <option value="15.00">15.00</option>
                              <option value="15.30">15.30</option>
                              <option value="16.00">16.00</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <!-- Same morning link -->
                      <div
                        class="form-group row custom-control custom-checkbox custom-control-solid ml-3 ml-sm-5 mb-2"
                      >
                        <div class="col-12 ml-3">
                          <input
                            v-model="range.ranges.afternoon.sameLink"
                            :disabled="stepForm === 3"
                            class="custom-control-input"
                            :id="`date${rangeId}_same`"
                            type="checkbox"
                            @change="
                              sameLink(range.ranges.afternoon.sameLink, rangeId)
                            "
                          />
                          <label
                            class="custom-control-label"
                            :for="`date${rangeId}_same`"
                          >Link เหมือนช่วงเช้า</label
                          >
                        </div>
                      </div>

                      <!-- Afternnon Meeting Link -->
                      <div class="form-group row">
                        <div class="offset-1 col-10">
                          <label
                            :for="`${range.date}_afternoon_inputLink`"
                            class="font-weight-normal required"
                          >Link</label
                          >
                          <input
                            v-model="range.ranges.afternoon.meeting_link"
                            :disabled="stepForm === 3"
                            type="text"
                            class="form-control col-10 form-control-user "
                            :id="`${range.date}_afternoon_inputLink`"
                            placeholder="Link Meeting Room "
                            style="padding: 1.2rem 1rem;"
                          />
                          <small class="input-hint"><small class="red-color">*</small>เฉพาะ Zoom meeting และ Microsoft Team meeting เท่านั้น</small>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <div class="form-group row mt-4">
            <div class="form-group row custom-control custom-radio ml-2">
              <div class="col-12">
                <input
                  :disabled="stepForm === 3"
                  class="custom-control-input"
                  id="meetingRadio2"
                  type="radio"
                  :value="false"
                  v-model="form.online_meeting"
                />
                <label
                  class="h5 custom-control-label text-engineer"
                  for="meetingRadio2"
                >ไม่มีช่องทางสำหรับ Video Call/Online Meeting ในช่วง Job Fair</label
                >
              </div>
            </div>
          </div>
        </register-form>
      </div>
    </fade-transition>

    <div class="col-12 offset-sm-1 col-sm-10 user pb-5">
      <div class="row text-center">
        <hr class="col-10" />
      </div>
      <div class="row my-3 d-flex justify-content-center">
        <div class="col-4">
          <button
            @click="onSubmit"
            v-if="stepForm === 3"
            class="btn btn-black btn-user btn-block"
          >
            Register
          </button>
          <button
            @click="changeStep(stepForm, stepForm + 1)"
            v-else
            class="btn btn-black btn-user btn-block"
          >
            ถัดไป
          </button>
        </div>
      </div>
    </div>
    <b-modal hide-header v-model="openModal" size="lg">

      <div class="d-flex justify-content-center mt-5">
        {{contentModal}}
      </div>
      <template v-if="nonFields !== []">
        <ul>
          <li :key="`nonfields-${index}`" v-for="(field, index) in nonFields">
            {{field}}
          </li>
        </ul>
      </template>

      <template v-slot:modal-footer>
        <div class="d-flex justify-content-end w-100">
          <div>
            <b-button @click="openModal = false"
                      class="btn-engineer btn-user btn-block mt-0">
              <h6 class="mb-0 w-auto">ปิด</h6>
            </b-button>
          </div>
        </div>

      </template>
    </b-modal>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import registerHead from "@/components/forms/registerHead";
  import registerForm from "@/components/forms/registerForm";
  import moment from "moment";
  import api from "@/services/api";
  import allCity from "@/data/allCity.json"
  import allProvince from "@/data/allProvince.json"

  moment.locale("th");

  // eslint-disable-next-line no-unused-vars
  import firebase from "firebase/app";
  import "firebase/auth";

  // Import Vue FilePond
  import vueFilePond from "vue-filepond";

  // Import FilePond styles
  import "filepond/dist/filepond.min.css";

  // Import FilePond plugins
  // Please note that you need to install these plugins separately

  // Import image preview plugin styles
  import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

  // Import imagane preview d file type validation plugins
  import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
  import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
  import FilePondPluginImagePreview from "filepond-plugin-image-preview";

  const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginFileValidateSize,
    FilePondPluginImagePreview
  );

  export default {
    title: "Job Fair Faculty of Engineering - Register",
    name: "register",
    computed: {
      ...mapGetters(["getStatus"])
    },
    components: {
      registerHead,
      registerForm,
      FilePond
    },
    data() {
      return {
        morning: {
          start_time: "",
          end_time: "",
          meeting_link: ""
        },
        form: {
          address: {
            building_road: "",
            city: "",
            province: "",
            subDistrict: "",
            zip_code: ""
          },
          available_job: "",
          benefits: "",
          brochure: "",
          contact_person: {
            email: "",
            firstName: "",
            lastName: "",
            phone: "",
            position: ""
          },
          description: "",
          display: "",
          email: "",
          fields: "",
          id: "",
          industry_group: {
            industry: "",
            otherIndustry: ""
          },
          interest_faculties: [],
          interest_fields: [],
          jobs: [],
          location: "",
          meeting_times: [],
          name: {
            th: "",
            en: ""
          },
          online_meeting: true,
          password: "",
          phone: "",
          probation: "",
          profile: "",
          repeat_password: "",
          status: "",
          website: "",
          workdays: ""
        },
        faculties: [
          "วศ.บ. วิศวกรรมการผลิตชิ้นส่วนยานยนต์",
          "วท.บ. วิทยาศาสตร์ข้อมูลสุขภาพ",
          "วศ.บ. วิศวกรรมคอมพิวเตอร์",
          "วศ.บ. วิศวกรรมคอมพิวเตอร์ (หลักสูตรนานาชาติ)",
          "วศ.บ. วิศวกรรมเคมี ",
          "วศ.บ. วิศวกรรมเคมี (หลักสูตรนานาชาติ)",
          "วศ.บ. วิศวกรรมเครื่องกล",
          "วศ.บ. วิศวกรรมเครื่องกลและพลังงาน",
          "วศ.บ. วิศวกรรมเครื่องมือ",
          "วศ.บ. วิศวกรรมไฟฟ้า",
          "วศ.บ. วิศวกรรมไฟฟ้า (ระบบไฟฟ้า อิเล็กทรอนิกส์ และพลังงาน)",
          "วศ.บ. วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์",
          "วศ.บ. วิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์ (หลักสูตรนานาชาติ)",
          "วศ.บ. วิศวกรรมเมคคาทรอนิกส์",
          "วศ.บ. วิศวกรรมยานยนต์",
          "วศ.บ. วิศวกรรมโยธา",
          "วศ.บ. วิศวกรรมโยธา (หลักสูตรนานาชาติ)",
          "วศ.บ. วิศวกรรมระบบควบคุมและเครื่องมือวัด",
          "วศ.บ. วิศวกรรมวัสดุ",
          "วศ.บ. วิศวกรรมสิ่งแวดล้อม",
          "วศ.บ. วิศวกรรมสิ่งแวดล้อม (หลักสูตรนานาชาติ)",
          "วศ.บ. วิศวกรรมอัตโนมัติ (หลักสูตรนานาชาติ) ",
          "วศ.บ. วิศวกรรมอุตสาหการ"
        ],
        industryGroup: [
          "ธุรกิจการผลิตทั่วไป",
          "ธุรกิจขนส่งสินค้า",
          "ธุรกิจเครื่องจักรในอุตสาหกรรม/อุปกรณ์เครื่องกล",
          "ธุรกิจโทรคมนาคม",
          "ธุรกิจบรรจุภัณฑ์",
          "ธุรกิจปิโตรเคมี สารเคมี พลาสติก กระดาษ ",
          "ธุรกิจยานยนต์",
          "ธุรกิจวิศวกรรมก่อสร้าง วิศวกรรมโยธา ควบคุมอาคาร",
          "ธุรกิจวิศวกรรมเครื่องกล",
          "ธุรกิจวิศวกรรมพลังงาน",
          "ธุรกิจวิศวกรรมไฟฟ้า อิเล็กทรอนิกส์",
          "ธุรกิจสื่อ/สิ่งพิมพ์/การพิมพ์",
          "ธุรกิจอสังหาริมทรัพย์",
          "ธุรกิจอุตสาหกรรมเกษตร",
          "ธุรกิจอุตสาหกรรมอาหาร เครื่องดื่ม",
          "ธุรกิจอุปกรณ์ไฟฟ้า/อุปกรณ์อิเล็กทรอนิกส์",
          "ธุรกิจไอที เทคโนโลยีสารสนเทศ",
          "ธุรกิจอื่นๆ"
        ],
        stepForm: 0,
        steps: [
          {
            title: "ข้อมูลเบื้องต้น",
            subtitle: ""
          },
          {
            title: "ข้อมูลเกี่ยวกับ",
            subtitle: "บริษัท/ตำแหน่งที่รับ"
          },
          {
            title: "รายละเอียด Online Job Fair",
            subtitle: ""
          },
          {
            title: "ตรวจสอบและบันทึกข้อมูล",
            subtitle: ""
          }
        ],
        formData: {},
        onlineMeetingRanges: [
          {
            date: "21-03-2022",
            checked: false,
            ranges: {
              morning: {
                checked: false,
                start_time: "",
                end_time: "",
                meeting_link: ""
              },
              afternoon: {
                sameLink: false,
                checked: false,
                start_time: "",
                end_time: "",
                meeting_link: ""
              }
            }
          },
          {
            date: "22-03-2022",
            checked: false,
            ranges: {
              morning: {
                checked: false,
                start_time: "",
                end_time: "",
                meeting_link: ""
              },
              afternoon: {
                sameLink: false,
                checked: false,
                start_time: "",
                end_time: "",
                meeting_link: ""
              }
            }
          }
        ],
        isEmailFormat: true,
        isPhoneFormat: true,
        isPasswordFormat: true,
        allProvince: allProvince,
        allCity: allCity,
        openModal: false,
        contentModal: "",
        nonFields: []
      };
    },
    methods: {
      ...mapActions(["companyRegister", "emailverify"]),
      getDateth(range) {
        return moment(range, "DD-MM-YYYY")
          .format("LLLL")
          .split(" เวลา ")[0]
          .replace(2022, 2565)
          .replace(2021, 2564)
          .replace(2020, 2563);
      },
      selectedDate(range) {
        this.onlineMeetingRanges.forEach(r => {
          if (r.date === range.date) {
            r.checked = !r.checked;
          }
        });
      },
      selectedRange(range, time) {
        this.onlineMeetingRanges.forEach(r => {
          if (r.date === range.date) {
            r.ranges[time].checked = !r.ranges[time].checked;
          }
        });
      },
      sameLink(e, index) {
        if (e) {
          this.onlineMeetingRanges[
            index
            ].ranges.afternoon.meeting_link = this.onlineMeetingRanges[
            index
            ].ranges.morning.meeting_link;
        } else {
          this.onlineMeetingRanges[index].ranges.afternoon.meeting_link = "";
        }
      },
      onSubmit: async function () {
        let formData = new FormData();
        let display = new File(
          [this.$refs.formDisplay.getFiles()[0].file],
          this.$refs.formDisplay.getFiles()[0].file.name
        );
        let brochure = new File(
          [this.$refs.formBrochure.getFiles()[0].file],
          this.$refs.formBrochure.getFiles()[0].file.name
        );

        // eslint-disable-next-line no-unused-vars
        let user = {
          email: this.form.contact_person.email,
          password: this.form.password
        };
        // eslint-disable-next-line no-unused-vars
        let register_form = {
          address: {
            building_road: this.form.address.building_road,
            city: this.form.address.city[1],
            province: this.form.address.province[1],
            zip_code: this.form.address.zip_code
          },
          available_job: this.form.available_job,
          contact_person: {
            email: this.form.contact_person.email,
            firstName: this.form.contact_person.firstName,
            lastName: this.form.contact_person.lastName,
            phone: this.form.contact_person.phone,
            position: this.form.contact_person.position
          },
          description: this.form.description,
          email: this.form.email,
          id: "",
          industry_group: this.form.industry_group,
          interest_faculties: this.form.interest_faculties,
          meeting_times: this.form.meeting_times,
          name: this.form.name,
          online_meeting: this.form.online_meeting,
          status: "",
          website: this.form.website,
        };

        if (this.form.online_meeting === false) {
          register_form.meeting_times = this.onlineMeetingRanges;
        }

        this.companyRegister(user)
          .then(() => {
            if (firebase.auth().currentUser) {
              register_form.id = firebase.auth().currentUser.uid;
              firebase
                .auth()
                .currentUser.getIdToken(false)
                .then(idToken => {
                  formData.append("display", display);
                  formData.append("brochure", brochure);
                  formData.append("register_form", JSON.stringify(register_form));
                  this.alertModal("โปรดรอสักครู่ ระบบกำลังส่งข้อมูล");
                  api.registerData(idToken, formData).catch(err => {
                    console.log(err)
                  }).finally(() => {
                    // const isVerified = firebase.auth().currentUser.emailVerified;
                    // const isVerified = true;
                    // if (!isVerified) {
                    //   this.$router.push({
                    //     path: "/emailVerify"
                    //   });
                    // } else {
                    //   this.$router.push({
                    //     path: "/"
                    //   });
                    // }
                    this.$router.push({path: "/company/information"});
                  });
                })
              // .finally(() => {
              //   if (!firebase.auth().currentUser.emailVerified) {
              //     this.$router.push({
              //       path: "/emailVerify"
              //     });
              //   } else {
              //     this.$router.push({
              //       path: "/"
              //     });
              //   }
              //
              // });
            }
          })
          .catch(err => {
            console.log(`Register Error: ${err}`);
          });
      },
      changeStep(now, next) {
        let available = false;
        this.nonFields = [];

        if (next < now) {
          available = true;
        } else if (next === 1) {
          available = this.checkStepZero();
        } else if (next === 2) {
          available = this.checkStepZero() && this.checkStepFirst();
        } else if (next === 3) {
          available =
            this.checkStepZero() &&
            this.checkStepFirst() &&
            this.checkStepSecond();
        }

        if (available) {
          this.stepForm = next;
          window.scrollTo({
            top: 100,
            left: 100,
            behavior: 'smooth'
          });
        } else {
          // alert("กรุณากรอกข้อมูลให้ครบทุกช่อง ก่อนจะดำเนินการต่อไป");
          this.alertModal("กรุณากรอกข้อมูลให้ครบทุกช่อง", this.nonFields);
        }
      },
      checkStepZero() {
        let checkZeroStep = 0;
        let allFields = ["รหัสผ่าน", "ยืนยันรหัสผ่าน", "อาคาร/ถนน", "จังหวัด", "เขต/อำเภอ", "รหัสไปรษณีย์", "กลุ่มอุตสาหกรรม", "ชื่อสถานประกอบการ (ภาษาอังกฤษ)", "ชื่อสถานประกอบการ (ภาษาไทย)", "ชื่อ", "นามสกุล", "ตำแหน่ง", "โทรศัพท์", "E-mail (ใช้สำหรับการ Login เข้าสู่ระบบ)"];
        let passedFields = [];
        if (this.form.contact_person.email && this.isEmailFormat) {
          passedFields.push("E-mail (ใช้สำหรับการ Login เข้าสู่ระบบ)");
          checkZeroStep++;
        }
        if (this.form.password && this.isPasswordFormat) {
          passedFields.push("รหัสผ่าน");
          checkZeroStep++;
        }
        if (this.form.repeat_password && this.isPasswordFormat) {
          passedFields.push("ยืนยันรหัสผ่าน");
          checkZeroStep++;
        }
        if (this.form.contact_person.firstName) {
          passedFields.push("ชื่อ");
          checkZeroStep++;
        }
        if (this.form.contact_person.lastName) {
          passedFields.push("นามสกุล");
          checkZeroStep++;
        }
        if (this.form.contact_person.position) {
          passedFields.push("ตำแหน่ง");
          checkZeroStep++;
        }
        if (this.form.contact_person.phone) {
          passedFields.push("โทรศัพท์");
          checkZeroStep++;
        }
        if (this.form.name.en) {
          passedFields.push("ชื่อสถานประกอบการ (ภาษาอังกฤษ)");
          checkZeroStep++;
        }
        if (this.form.name.th) {
          passedFields.push("ชื่อสถานประกอบการ (ภาษาไทย)");
          checkZeroStep++;
        }
        if (this.form.industry_group.industry) {
          passedFields.push("กลุ่มอุตสาหกรรม");
          checkZeroStep++;
        }
        if (this.form.address.building_road) {
          passedFields.push("อาคาร/ถนน");
          checkZeroStep++;
        }
        if (this.form.address.city) {
          passedFields.push("เขต/อำเภอ");
          checkZeroStep++;
        }
        if (this.form.address.province) {
          passedFields.push("จังหวัด");
          checkZeroStep++;
        }
        if (this.form.address.zip_code) {
          passedFields.push("รหัสไปรษณีย์");
          checkZeroStep++;
        }

        allFields.forEach(field => {
          if (!passedFields.includes(field)) {
            this.nonFields.push(field)
          }
        });

        if (checkZeroStep === 14) {
          return true;
        } else {
          return false;
        }
      },
      checkStepFirst() {
        let checkFirstStep = 0;
        let allFields = ["Display", "โปสเตอร์/โบรชัวร์", "ข้อมูลเกี่ยวกับบริษัท", "ตำแหน่งที่รับ", "สาขาที่รับ", "E-mail สำหรับนักศึกษาติดต่อกลับ", "เว็บไซต์/เพจ ข้อมูลเพิ่มเติม"];
        let passedFields = [];
        if (this.$refs.formDisplay.getFiles().length > 0) {
          passedFields.push("Display");
          checkFirstStep++;
        }
        if (this.$refs.formBrochure.getFiles().length > 0) {
          passedFields.push("โปสเตอร์/โบรชัวร์");
          checkFirstStep++;
        }

        if (this.form.interest_faculties.length > 0) {
          passedFields.push("สาขาที่รับ");
          checkFirstStep++;
        }
        if (this.form.description) {
          passedFields.push("ข้อมูลเกี่ยวกับบริษัท");
          checkFirstStep++;
        }
        if (this.form.website) {
          passedFields.push("เว็บไซต์/เพจ ข้อมูลเพิ่มเติม");
          checkFirstStep++;
        }
        if (this.form.email) {
          passedFields.push("E-mail สำหรับนักศึกษาติดต่อกลับ");
          checkFirstStep++;
        }
        if (this.form.available_job) {
          passedFields.push("ตำแหน่งที่รับ");
          checkFirstStep++;
        }

        allFields.forEach(field => {
          if (!passedFields.includes(field)) {
            this.nonFields.push(field)
          }
        });

        if (checkFirstStep === 7) {
          return true;
        } else {
          return false;
        }
      },
      checkStepSecond() {
        if (this.form.online_meeting) {
          if (this.form.meeting_times.length > 0) {
            let m = 0;

            this.form.meeting_times.forEach(meeting_date => {
              if (meeting_date.checked) {
                let haveMeeting = 0;
                let afTime = 0;
                let mnTime = 0;
                if (meeting_date.ranges.afternoon.checked) {
                  if (meeting_date.ranges.afternoon.end_time) {
                    afTime++;
                  }
                  if (meeting_date.ranges.afternoon.start_time) {
                    afTime++;
                  }
                  if (afTime === 2) {
                    haveMeeting++;
                  } else {
                    return false;
                  }
                }
                if (meeting_date.ranges.morning.checked) {
                  if (meeting_date.ranges.morning.end_time) {
                    mnTime++;
                  }
                  if (meeting_date.ranges.morning.start_time) {
                    mnTime++;
                  }
                  if (mnTime === 2) {
                    haveMeeting++;
                  } else {
                    return false;
                  }
                }
                if (haveMeeting % 2 === 0 && mnTime === 2 && afTime === 2) {
                  m++;
                } else if (
                  haveMeeting % 2 === 1 &&
                  (mnTime === 2 || afTime === 2)
                ) {
                  m++;
                }
              }
            });

            return m === this.form.meeting_times.length;
          }
        } else {
          return true;
        }
      },
      alertModal(massage) {
        this.openModal = true;
        this.contentModal = massage
      },
      checkEmail(email) {
        let re = new RegExp(
          // eslint-disable-next-line no-useless-escape
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        this.isEmailFormat = re.test(email);
        return this.isEmailFormat;
      },
      checkPhone(phone) {
        let re = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);

        if (re.test(phone)) {
          let match = phone.match(/^(\d{3})(\d{3})(\d{4})$/);
          if (match) {
            this.form.phone = match[1] + "-" + match[2] + "-" + match[3];
          }
        }
        this.isPhoneFormat = re.test(phone);
        return re.test(phone);
      },
      checkPassword(password, repeatPassword) {
        if (password === repeatPassword) {
          this.isPasswordFormat = password.length >= 6;
        } else {
          this.isPasswordFormat = false;
        }
      },
    },
  };
</script>

<style scoped>
.btn-user {
  font-size: 0.8rem;
  border-radius: 10rem;
  padding: 0.75rem 1rem;
}
.input-hint {
  font-size: 12px;
}
.red-color {
  color: #cf362e;
  margin-right: 5px;
}
</style>
